function goToSubscribeForm() {
  const btn = document.getElementById('js-go-subscribe-form');

  if (btn) {
    btn.addEventListener('click', () => {
      const anchor = document.querySelector('#inschrijf-formulier').getBoundingClientRect().top,
            navElemHeight = document.getElementById('js-navigation').offsetHeight;

      window.scrollTo({
        top: anchor - navElemHeight
      });
    });
  }
}

function toggleExpertises() {
  const btn = document.getElementById('js-expertises');

  if (btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log(btn.parentElement);
    });
  }
}

function toggleList(id, type) {
  const btn = document.getElementById(id);

  if (btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const ulElement = btn.parentElement.parentElement;

      if (ulElement) {
        const liItems = ulElement.getElementsByClassName('align-items-center')
        for (let index = 5; index < liItems.length; index++) {
          const element = liItems[index];
          if (element.classList.contains('d-none')) {
            element.classList.remove('d-none');
            btn.innerHTML = 'Toon minder ' + type;
          } else {
            element.classList.add('d-none');
            btn.innerHTML = 'Toon meer ' + type;
          }
        }
      }
    });
  }
}

goToSubscribeForm();
toggleList('js-facilities', 'voorzieningen');
toggleList('js-expertises', 'expertises');

document.addEventListener("DOMContentLoaded", () => {
  const galleryContainers = document.querySelectorAll('.usn-gallery-image');
  
  // Check if any gallery containers exist
  if (galleryContainers.length === 0) {
    console.warn('No .usn-gallery-image containers found');
    return;
  }

  // Process all gallery containers
  galleryContainers.forEach(galleryContainer => {
    const galleryImages = galleryContainer.querySelectorAll('img');
    
    // Skip if no images in this container
    if (galleryImages.length === 0) {
      return;
    }

    // Wrap each image in a <button> and ensure accessibility
    galleryImages.forEach(img => {
      const button = document.createElement('button');
      button.classList.add('gallery-img-button');
      button.setAttribute('type', 'button');
      button.setAttribute('aria-label', img.alt || 'View image in lightbox');

      img.setAttribute('role', 'presentation'); // Image used purely for visual
      img.setAttribute('tabindex', '-1'); // Prevent tabbing to img itself

      img.parentNode.insertBefore(button, img);
      button.appendChild(img);
    });
  });

  // Create lightbox container
  const lightbox = document.createElement('div');
  lightbox.id = 'lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Image preview');

  Object.assign(lightbox.style, {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0)',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    flexDirection: 'column',
    // Animation properties
    opacity: '0',
    transition: 'opacity 0.3s ease-in-out, background-color 0.3s ease-in-out',
    backdropFilter: 'blur(0px)'
  });

  // Close button
  const closeButton = document.createElement('button');
  closeButton.setAttribute('aria-label', 'Close lightbox');
  closeButton.innerHTML = '&times;';
  Object.assign(closeButton.style, {
    position: 'absolute',
    top: '20px',
    right: '30px',
    fontSize: '2rem',
    color: '#fff',
    background: 'transparent',
    border: 'none',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    cursor: 'pointer',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Animation properties
    transform: 'scale(0) rotate(90deg)',
    transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
    opacity: '0'
  });

  // Add hover effect to close button
  closeButton.addEventListener('mouseenter', () => {
    closeButton.style.transform = closeButton.style.transform.replace('scale(1)', 'scale(1.1)');
  });

  closeButton.addEventListener('mouseleave', () => {
    closeButton.style.transform = closeButton.style.transform.replace('scale(1.1)', 'scale(1)');
  });

  // Image inside lightbox
  const lightboxImage = document.createElement('img');
  lightboxImage.setAttribute('alt', '');
  Object.assign(lightboxImage.style, {
    maxWidth: '90%',
    maxHeight: '90%',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
    // Animation properties
    transform: 'scale(0.8) translateY(20px)',
    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
    opacity: '0'
  });

  lightbox.appendChild(closeButton);
  lightbox.appendChild(lightboxImage);
  document.body.appendChild(lightbox);

  let lastFocusedButton = null;
  let isAnimating = false;

  // Handle click event for all gallery buttons
  const lightboxButtons = document.querySelectorAll('.gallery-img-button');
  lightboxButtons.forEach(button => {
    button.addEventListener('click', () => {
      if (isAnimating) return;
      
      const img = button.querySelector('img');
      lightboxImage.src = img.src;
      lightboxImage.alt = img.alt || 'Lightbox image';
      
      openLightbox();
      lastFocusedButton = button;
    });
  });

  function openLightbox() {
      isAnimating = true;
      
      // Show lightbox
      lightbox.style.display = 'flex';
      
      // Force reflow
      lightbox.offsetHeight;
      
      // Animate background
      lightbox.style.opacity = '1';
      lightbox.style.background = 'rgba(0, 0, 0, 0.8)';
      lightbox.style.backdropFilter = 'blur(5px)';
      
      // Animate close button
      setTimeout(() => {
          closeButton.style.opacity = '1';
          closeButton.style.transform = 'scale(1) rotate(0deg)';
      }, 100);
      
      // Animate image
      setTimeout(() => {
          lightboxImage.style.opacity = '1';
          lightboxImage.style.transform = 'scale(1) translateY(0px)';
      }, 150);
      
      // Focus and end animation
      setTimeout(() => {
          closeButton.focus();
          isAnimating = false;
      }, 400);
  }

  // Trap focus inside the lightbox
  document.addEventListener('keydown', (e) => {
    if (lightbox.style.display === 'flex') {
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'Tab') {
        // Simple focus trap for only one button
        e.preventDefault();
        closeButton.focus();
      }
    }
  });

  // Close on background click
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox && !isAnimating) {
      closeLightbox();
    }
  });

  closeButton.addEventListener('click', () => {
    if (!isAnimating) {
      closeLightbox();
    }
  });

  function closeLightbox() {
    if (isAnimating) return;
    
    isAnimating = true;
    
    // Animate image out
    lightboxImage.style.opacity = '0';
    lightboxImage.style.transform = 'scale(0.8) translateY(20px)';
    
    // Animate close button out
    closeButton.style.opacity = '0';
    closeButton.style.transform = 'scale(0) rotate(-90deg)';
    
    // Animate background out
    setTimeout(() => {
      lightbox.style.opacity = '0';
      lightbox.style.background = 'rgba(0, 0, 0, 0)';
      lightbox.style.backdropFilter = 'blur(0px)';
    }, 100);
    
    // Hide lightbox and restore focus
    setTimeout(() => {
      lightbox.style.display = 'none';
      
      // Reset styles for next opening
      lightboxImage.style.transform = 'scale(0.8) translateY(20px)';
      lightboxImage.style.opacity = '0';
      closeButton.style.transform = 'scale(0) rotate(90deg)';
      closeButton.style.opacity = '0';
      
      if (lastFocusedButton) {
        lastFocusedButton.focus();
      }
      
      isAnimating = false;
    }, 400);
  }
});